export const GET_VACANCY_REQUEST = 'GET_VACANCY_REQUEST';
export const GET_VACANCY_SUCCESS = 'GET_VACANCY_SUCCESS';
export const GET_VACANCY_FAIL = 'GET_VACANCY_FAIL';

export const GET_ALL_VACANCIES_REQUEST = 'GET_ALL_VACANCIES_REQUEST';
export const GET_ALL_VACANCIES_SUCCESS = 'GET_ALL_VACANCIES_SUCCESS';
export const GET_ALL_VACANCIES_FAIL = 'GET_ALL_VACANCIES_FAIL';
